
import { defineComponent } from 'vue'
import {
  getTableProperties,
  request,
  Table,
  TableRequestProps,
} from '@/utils/request'
import getColumns from './getColumns'
import AddDomainDialog from '@/components/dialogs/AddDomainDialog.vue'
export default defineComponent({
  name: 'RedirectDomains',
  components: { AddDomainDialog },
  async created() {
    await this.onRequest({ pagination: this.pagination })
  },
  data() {
    return {
      ...getTableProperties('id'),
      showAddDomainDialog: false,
    }
  },
  methods: {
    async onRequest(props: TableRequestProps) {
      const options = props || { pagination: this.pagination }
      await request(options, this as Table, '/api/redirect-domains/affiliate/')
    },
  },
  computed: {
    createColumns() {
      return getColumns()
    },
  },
})
